import { scaffolderPlugin } from '@backstage/plugin-scaffolder';
import { createScaffolderFieldExtension } from '@backstage/plugin-scaffolder-react';
import { CustomUserField } from './CustomUserField';

export const CustomUserFieldExtension = scaffolderPlugin.provide(
  createScaffolderFieldExtension({
    name: 'CustomUserField',
    component: CustomUserField,
  }),
);